import React, { useContext } from "react";

const ShopGridContext = React.createContext(null);

export const ShopGridProvider = ShopGridContext.Provider;

export const useShopGridContext = () => {
  const value = useContext(ShopGridContext);
  if (!value) {
    throw new Error("useShopGridContext deve essere usato dentro ShopGridProvider");
  }
  return value;
};

